<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Modifier une ligne du temps</p>
		</header>
		<section class="modal-card-body">
			<form method="POST">
                        <!-- Title field -->
                        <b-field label="Titre de la ligne du temps" :type="form.errors.has('title') ? 'is-danger' : ''" :message="form.errors.first('title')">
                                <b-input type="text" v-model="form.title" autofocus maxlength="100" has-counter> </b-input>
                        </b-field>

                        <!-- Description field -->
                        <b-field label="Description de la ligne du temps" :type="form.errors.has('description') ? 'is-danger' : ''" :message="form.errors.first('description')">
                                <b-input type="textarea" v-model="form.description" @keydown.enter.native.prevent maxlength="250" has-counter> </b-input>
                        </b-field>
                    </form>
		</section>
		<footer class="modal-card-foot">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Enregistrer les modifications</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
	</div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: ['timeline'],

    data() {
        return {
            form: new Form({
                title: '',
                description: ''
            }),
        }
    },
    
    methods: {

        submit() {

            this.form.put('/api/v1/timelines/'+this.$route.params.id, {
                title: this.title,
                description: this.description
            }).then( response => {

                this.$buefy.toast.open({
                    message: 'Vos modifications ont été enregistrées',
                    type: 'is-success'
                });

                Bus.$emit('timeline.fetch');
                this.$parent.close()

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },
    },

    created() {
        this.form.title = this.timeline.title;
        this.form.description = this.timeline.description;
    }
}

</script>

<style>
</style>
